import React, { useState } from 'react';
import { ForgeButton, ForgeOpenIcon, ForgePopover, ForgeList } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import { useSaveAsModal } from '../SaveAsDerivedReport/StorySaveAs';
import { useDerivedReport } from '../DerivedReportContext';
import { UpdateDerivedReport } from '../UpdateDerivedReport/UpdateDerivedReport';
import { IPopoverToggleEventData } from '@tylertech/forge';

export function StorySaveDropdown() {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { canCreate, canUpdate } = useDerivedReport();

  const { SaveAsListItem, SaveAsDialog } = useSaveAsModal();

  const handlePopoverClose = () => {
    setPopoverOpen(false);
  };

  const handlePopoverToggle = (event: CustomEvent<IPopoverToggleEventData>) => {
    setPopoverOpen(event.detail.newState === 'open');
  };

  return (
    <>
      <ForgeButton
        variant="text"
        dense
        id="save-changes-button"
        data-testid="save-report-changes-button"
        onClick={() => setPopoverOpen((prev) => !prev)}
      >
        {I18n.t('derived_story.save_changes')}
        <ForgeOpenIcon slot="end" open={popoverOpen} />
      </ForgeButton>

      <ForgePopover placement="bottom-start" open={popoverOpen} on-forge-popover-toggle={handlePopoverToggle}>
        <ForgeList className="save-changes-options">
          {canUpdate && (
            <div onClick={handlePopoverClose}>
              <UpdateDerivedReport />
            </div>
          )}
          {canCreate && <div onClick={handlePopoverClose}>{SaveAsListItem}</div>}
        </ForgeList>
      </ForgePopover>

      {SaveAsDialog}
    </>
  );
}
